// Load rivalry data for a given manager from /data/manager_rivalries.csv

import { parseCSV } from './csv';
import { normalizeManagerName } from './managerStats';

const RIVALRIES_CSV = '/data/manager_rivalries.csv';

export async function loadRivalriesFor(managerName) {
  if (!managerName) return [];
  const response = await fetch(RIVALRIES_CSV);
  if (!response.ok) throw new Error('Failed to load rivalry data');

  const rows = parseCSV(await response.text());
  // Merge: collapse any rivalry rows where the normalized manager matches.
  const buckets = new Map();
  for (const row of rows) {
    if (normalizeManagerName(row.manager) !== normalizeManagerName(managerName)) continue;
    const opp = normalizeManagerName(row.opponent);
    const wins = parseInt(row.wins, 10) || 0;
    const losses = parseInt(row.losses, 10) || 0;
    const games = parseInt(row.total_games, 10) || 0;
    const avgMargin = parseFloat(row.avg_margin) || 0;
    const existing = buckets.get(opp);
    if (existing) {
      existing.wins += wins;
      existing.losses += losses;
      existing.total_games += games;
      existing._weightedMargin += avgMargin * games;
    } else {
      buckets.set(opp, {
        opponent: opp, wins, losses, total_games: games,
        _weightedMargin: avgMargin * games,
        dominance_level: row.dominance_level || 'Even',
      });
    }
  }
  const rivalries = Array.from(buckets.values()).map((r) => {
    const winRate = r.total_games > 0 ? (100 * r.wins / r.total_games) : 0;
    return {
      opponent: r.opponent,
      wins: r.wins,
      losses: r.losses,
      total_games: r.total_games,
      win_rate: +winRate.toFixed(1),
      avg_margin: r.total_games > 0 ? +(r._weightedMargin / r.total_games).toFixed(2) : 0,
      dominance_level: r.dominance_level,
    };
  });
  rivalries.sort((a, b) => b.total_games - a.total_games);
  return rivalries;
}

export function rivalRate(rivalries, opponent) {
  const r = rivalries.find((x) => x.opponent === opponent);
  return r?.win_rate ?? 0;
}

export function rivalGames(rivalries, opponent) {
  const r = rivalries.find((x) => x.opponent === opponent);
  return r?.total_games ?? 0;
}
